import dynamic from 'next/dynamic';
export const SvgIcon = dynamic(() => import('./Icon/SvgIcon'));
export default SvgIcon;
export const EFHeaderLeftIcon = dynamic(() => import('./Icon/EFHeaderLeftIcon'));
export const EFHeaderSearch = dynamic(() => import('./Icon/EFHeaderSearch'));
export const EFHeaderSearch2 = dynamic(() => import('./Icon/EFHeaderSearch2'));
export const EFHeaderSearchForSearch = dynamic(() => import('./Icon/EFHeaderSearchForSearch'));
export const EFLogo = dynamic(() => import('./Icon/EFLogo'));
export const EFLogoH5 = dynamic(() => import('./Icon/EFLogoH5'));
export const EFStore = dynamic(() => import('./Icon/EFStore'));
export const EFDelete = dynamic(() => import('./Icon/EFDelete'));
export const EFDeleteForDialog = dynamic(() => import('./Icon/EFDeleteForDialog'));
